import Cookies from 'universal-cookie';

enum GoogleCookieNames {
  ClientId = '_ga',
  SessionId = '_ga_',
}

export const getGoogleClientId = () => {
  try {
    const cookies = new Cookies();

    const googleCookie = cookies.get(GoogleCookieNames.ClientId);

    if (!googleCookie) {
      return undefined;
    }

    return googleCookie.split('.').slice(-2).join('.');
  } catch (e) {
    console.error(`failed parsing google client id`, e);
    return undefined;
  }
};

export const getGoogleSessionId = (gaId: string) => {
  if (!gaId) {
    return undefined;
  }

  try {
    const cookies = new Cookies();

    const slicedGaId = gaId.slice(2);
    const googleCookie = cookies.get(GoogleCookieNames.SessionId + slicedGaId);

    if (!googleCookie) {
      return undefined;
    }

    const sessionId = googleCookie.match(/(?:^|\.)(?:s)(\d+)\$/);
    return sessionId?.[1];
  } catch (e) {
    console.error(`failed parsing google session coockie`, e);
    return undefined;
  }
};
